import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {CategoryDetail} from "./category-detail";

const CategoryDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/categories');
    }

    return (
        <CategoryDetail id={id} onClose={onClose}/>
    )

});

export default CategoryDetailPage;